<template>
  <modal
    v-slot="{ data }"
    name="empty-cart-modal"
    modal-style="compact"
    :display-header-title="false"
  >
    <empty-cart :data="data" />
  </modal>
</template>


<script>
  import EmptyCart from './empty-cart/index.vue';


  export default {
    name: 'EmptyCartModal',

    components: {
      EmptyCart
    }
  };
</script>
